/** Control name constants for the revoke-order reactive form. */
export enum RevokeOrderFormControl {
  Name = 'name',
  Email = 'email',
  OrderNumber = 'orderNumber',
  Articles = 'articles',
  Reason = 'reason',
}

/** Form data captured in Tab 1; all string values are trimmed before submission. */
export interface RevokeOrderFormData {
  name: string;
  email: string;
  orderNumber: string;
  articles: string | null;
  reason: string | null;
}
